import React from "react"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography
} from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import { defineMessages } from "react-intl"
import LocaleSelect from "../select/LocaleSelect"
import { updateLocale } from "../../i18n/localeUtils"
import useSmartFormat from "../../i18n/useSmartFormat"

const useLocaleStyles = makeStyles((theme) => ({
  localeSelect: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(3)
  },
  licenseText: {
    whiteSpace: "pre-wrap"
  }
}))

const messages = defineMessages({
  title: {
    id: "licenseAgreement.title",
    defaultMessage: "End-user license agreement"
  },
  subtitle: {
    id: "licenseAgreement.subtitle",
    defaultMessage:
      "You must read and accept the license agreement to access the Webportal."
  },
  agree: {
    id: "licenseAgreement.agree",
    defaultMessage: "Agree and continue"
  },
  decline: {
    id: "licenseAgreement.decline",
    defaultMessage: "Decline"
  }
})

export default function LicenseAgreementDialog({
  onAccept,
  onReject,
  open,
  noLocaleSelect,
  isPreview,
  licenseText,
  ...dialogProps
}) {
  const classes = useLocaleStyles()
  const format = useSmartFormat()
  const userLocale = useSelector((state) => state.intl.locale)
  const dispatch = useDispatch()

  function onLocaleChange(newLocale) {
    dispatch(updateLocale(newLocale))
  }

  return (
    <Dialog open={open} {...dialogProps}>
      {!noLocaleSelect && (
        <LocaleSelect
          className={classes.localeSelect}
          onChange={onLocaleChange}
          value={userLocale}
        />
      )}
      <Box p={3}>
        <Typography variant="h6" component="h1">
          {format(messages.title)}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          {format(messages.subtitle)}
        </Typography>
      </Box>
      <DialogContent dividers>
        <div dangerouslySetInnerHTML={{ __html: licenseText }} />
      </DialogContent>
      {!isPreview && (
        <DialogActions>
          <Button variant="outlined" size="small" onClick={onReject}>
            {format(messages.decline)}
          </Button>
          <Button
            disableElevation
            color="primary"
            variant="contained"
            size="small"
            onClick={onAccept}
          >
            {format(messages.agree)}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}

LicenseAgreementDialog.propTypes = {
  isPreview: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  onAccept: PropTypes.func,
  onReject: PropTypes.func,
  licenseText: PropTypes.string.isRequired,
  noLocaleSelect: PropTypes.bool
}

LicenseAgreementDialog.defaultProps = {
  noLocaleSelect: false,
  onAccept: undefined,
  onReject: undefined
}
